import React from 'react';

import { UserAvatar } from './UserAvatar';
import useUser from './react-hooks/useUser';

// Ids that aren't real users (see UserAvatar): nothing to look up
const isNotARealUserId = id => !id || id.startsWith('casual-') || id === 'sheetScript' || id.includes('-bot') || id === 'gemini';

/**
 * UserAvatar completed with the users info service (cached and batched, see useUser): renders right away with
 * what it's given (an id, or a stored { id, username } signature as `user`), then with the current username,
 * level (→ 🤖 badge for bot_contributor) and isPremium once they arrive. Only queries inside admin pages
 * (LegoAdminPageContext): elsewhere it's a plain UserAvatar.
 */
export function UserAvatarLive({ id: userId, user, ...other }) {
  const id = (user?.id ?? userId ?? '').toString();
  const userData = useUser(isNotARealUserId(id) ? undefined : id);

  if (userData) {
    return <UserAvatar user={{ ...user, ...userData }} {...other}/>;
  } else if (user) {
    return <UserAvatar user={user} id={userId} {...other}/>;
  } else {
    return <UserAvatar id={userId} {...other}/>;
  }
}
